<template>
  <v-form class="booking-form" ref="bookingForm">
    <div class="booking-form_fields">
      <div class="booking-form_fields-inner">
        <div class="booking-form_field booking-form_field--dates">
          <span class="booking-form_field-label">Дата заезда-выезда</span>
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            v-model="dateMenu"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="Дата заезда"
                readonly
                v-on="on"
                solo
                class="ui-input"
                hide-details
                :value="dispDates"
              >
                <template v-slot:prepend-inner>
                  <v-icon>$calendar</v-icon>
                </template>
              </v-text-field>
            </template>

            <v-date-picker
              class="ui-datepicker"
              width="auto"
              locale="ru-ru"
              v-model="dates"
              no-title
              range
              :min="(new Date()).toISOString()"
              @change="onDatepickerChange"
              :first-day-of-week="calStartDay"
              :weekday-format="helpers.getWeekDay"
            />
          </v-menu>
        </div>

        <div class="booking-form_field booking-form_field--days">
          <span class="booking-form_field-label">Количество дней</span>
          <v-text-field
            solo
            v-model="daysCnt"
            @keydown="checkKey($event, /[\d]/)"
            @change="onDaysCntChange"
            class="ui-input"
            hide-details
            :rules="[validationRules.required]"
          ></v-text-field>
        </div>

        <div class="booking-form_field booking-form_field--guests">
          <span class="booking-form_field-label">Количество гостей</span>
          <guests-field
            :data="guestsLocal"
            @update="onGuestsCntUpdate"
          />
        </div>

        <div class="booking-form_field booking-form_field--buy-mode">
            <span class="booking-form_field-label">
              &nbsp;
            </span>
          <div class="booking-form_field-input-wrapper">
            <label for="#" class="booking-form_field-switch-label"
                   @click="setIsPresent(false)"
                   :class="isPresent ? '' : 'booking-form_field-switch-label--choose'">
              Я покупаю
            </label>
            <image-switch v-model="isPresent"
                          falseImg=""
                          trueImg=""
                          height="var(--image-switch-height)"
                          width="6rem"
                          trueMarkerImgSize="70%"
                          :falseMarkerImg="require('@/assets/img/misc/success-pic-bg-empty.svg')"
                          :trueMarkerImg="require('@/assets/img/misc/gift-pic.svg')"
                          falseMarkerColor="var(--prime-color)"
                          falseBGColor="#fff"
                          trueBGColor="linear-gradient(94.11deg, #FC9C97 7.37%, #FFAC7E 100%)">
            </image-switch>
            <label for="#" class="booking-form_field-switch-label"
                   @click="setIsPresent(true)"
                   :class="isPresent ? 'booking-form_field-switch-label--choose' : ''">
              Я дарю
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="booking-form_actions">
      <a
        href="javascript:void(0)"
        class="ui-btn ui-btn--yellow booking-form_action"
        @click.prevent="onSubmit"
      >
        Найти номер
      </a>
    </div>
  </v-form>
</template>

<script>
import Helpers from '@/helpers/Helpers'
import { IMaskDirective } from 'vue-imask'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import ImageSwitch from '@/components/UI/ImageSwitch'
import GuestsField from '@/components/GuestsField'

export default {
  name: `booking-form`,

  directives: {
    imask: IMaskDirective
  },

  components: {
    ImageSwitch,
    GuestsField,
  },

  data: () => {
    return {
      dateIn: null,
      dateOut: null,
      dates: [],
      daysCnt: null,
      guestsValue: '1',
      validationRules: {
        required: value => !!value || 'Обязательно к заполнению.',
      },
      dateMenu: false,
      searchOnMounted: false,
      isPresentValue: false,
      guestsLocal: [],
    }
  },

  computed: {
    ...mapState({
      minDays: state => state.selection.minDays,
      maxDays: state => state.selection.maxDays,
      defaultDaysCnt: state => state.selection.defaultDaysCnt,
      storeDateIn: state => state.selection.dateIn,
      storeDateOut: state => state.selection.dateOut,
      guests: state => state.selection.guests,
      settingsSpaTour: state => state.dictionaries.settingsSpaTour,
      // spaTour: state => state.dictionaries.spaTour,
    }),

    ...mapGetters({
      spaTour: [`dictionaries/checkSpaTourAvailable`],
    }),

    calStartDay() {
      return process.env.VUE_APP_SEARCH_CAL_START_DAY || 0
    },

    helpers() {
      return Helpers
    },

    isPresent: {
      get() {
        return this.isPresentValue;
      },
      set(value) {
        this.setIsPresentStore(value);
        this.isPresentValue = value;
      }
    },

    dispDates() {
      let start
      let end
      let str = ''

      if(this.dateIn) {
        start = this.dateIn.split('-')
        str = `${start[2]}.${start[1]}.${start[0]}`
      }

      if(this.dateOut) {
        end = this.dateOut.split('-')
        str += ` - ${end[2]}.${end[1]}.${end[0]}`
      }

      return str
    },
  },

  methods: {
    ...mapActions({
      changeDateIn: 'selection/changeDateIn',
      changeDateOut: 'selection/changeDateOut',
      changeGuestsCnt: 'selection/changeGuestsCnt',
      fetchAvilableVariants: 'selection/fetchVariants',
    }),

    ...mapMutations({
      setIsPresentStore: 'selection/setIsPresent',
      updateGuests: 'selection/updateGuests',
    }),

    setIsPresent(value) {
      this.isPresent = value;
    },

    calculateSpaTourThreshold() {
      const defaultThreshold = 14;

      if (!this.settingsSpaTour || !this.settingsSpaTour['kluchi']) {
        return defaultThreshold;
      }

      const settings = this.settingsSpaTour['kluchi'];

      if (settings.openBefore) {
        const now = new Date();
        const openBeforeDate = new Date(settings.openBefore);
        const daysDiff = Math.ceil((openBeforeDate - now) / (1000 * 60 * 60 * 24));
        const result = Math.max(0, daysDiff);
        if (isNaN(result)) {
          console.log('error:ошибка преобразования дат из settings.openBefore');
          return defaultThreshold;
        } else {
          return result;
        }
      }

      if (settings.bookingPeriod) {
        return +settings.bookingPeriod;
      }

      return defaultThreshold;
    },

    onDatepickerChange(arr) {
      let sortedArr = arr.slice()
        .sort(function(a, b) {
          return new Date(a) - new Date(b)
        })
      let now = new Date()
      let daysCnt = ( new Date(sortedArr[1]) - new Date(sortedArr[0]) ) / 1000 / 60 / 60 / 24

      this.dateIn = sortedArr[0]

      if(daysCnt < this.minDays) {
        // если есть флаг спа туров и дата заезда меньше чем текущая + 2 недели,
        // то можно выбрать кол-во дней меньше минимального лимита
        const daysThreshold = this.calculateSpaTourThreshold();
        if(this.spaTour && new Date(this.dateIn) < new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysThreshold)) {
          let dateOutObj = new Date(sortedArr[1])

          switch(daysCnt) {
            case 1:
              this.daysCnt = 2
              this.dateOut = new Date(dateOutObj.getFullYear(), dateOutObj.getMonth(), dateOutObj.getDate() + 2).toISOString().substring(0, 10)
              break
            case 4:
              this.daysCnt = 5
              this.dateOut = new Date(dateOutObj.getFullYear(), dateOutObj.getMonth(), dateOutObj.getDate() + 2).toISOString().substring(0, 10)
              break
            case 6:
              this.daysCnt = 7
              this.dateOut = new Date(dateOutObj.getFullYear(), dateOutObj.getMonth(), dateOutObj.getDate() + 2).toISOString().substring(0, 10)
              break
            default:
              this.daysCnt = daysCnt
              this.dateOut = sortedArr[1]
              break
          }

        } else {
          let dateInObj = new Date(sortedArr[0])
          let dateOutObj = new Date(dateInObj.getFullYear(), dateInObj.getMonth(), dateInObj.getDate() + +this.minDays + 1)
          this.daysCnt = this.minDays
          this.dateOut = dateOutObj.toISOString().substring(0, 10)
        }
      } else if(daysCnt > this.maxDays) {
        let dateInObj = new Date(sortedArr[0])
        let dateOutObj = new Date(dateInObj.getFullYear(), dateInObj.getMonth(), dateInObj.getDate() + +this.maxDays)
        this.daysCnt = this.maxDays
        this.dateOut = dateOutObj.toISOString().substring(0, 10)
      } else {
        this.daysCnt = daysCnt
        this.dateOut = sortedArr[1]
      }

      this.changeDateIn(this.dateIn)
      this.changeDateOut(this.dateOut)
      this.dates = [this.dateIn, this.dateOut]
      this.dateMenu = false
    },

    onDaysCntChange(val) {
      let daysCnt = +val
      let dateInObj = new Date(this.dateIn)
      let now = new Date()

      if(+val < +this.minDays) {

        // если есть флаг спа туров и дата заезда меньше чем текущая + 2 недели,
        // то можно выбрать кол-во дней меньше минимального лимита
        const daysThreshold = this.calculateSpaTourThreshold();
        if(this.spaTour && dateInObj < new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysThreshold)) {
          switch(daysCnt) {
            case 1:
              daysCnt = 2
              break
            case 4:
              daysCnt = 5
              break
            case 6:
              daysCnt = 7
              break
            default:
              break
          }
        } else {
          daysCnt = +this.minDays
        }
      } else if (+val > this.maxDays) {
        daysCnt = this.maxDays
      }

      this.daysCnt = daysCnt
      this.dateOut = new Date(
        dateInObj.getFullYear(),
        dateInObj.getMonth(),
        dateInObj.getDate() + (daysCnt > 1 ? daysCnt + 1 : daysCnt)
      ).toISOString().substring(0, 10)

      this.changeDateOut(this.dateOut)

      this.dates = [this.dateIn, this.dateOut]
    },

    checkKey(e, pattern) {
      const allowedKeys = [8, 9, 13, 16, 17, 18, 27, 32, 37, 38, 39, 40]
      let keyCode = e.which || e.keyCode
      let keyValue = e.key

      if(
        allowedKeys.indexOf(keyCode) === -1
        && !pattern.test(keyValue)
      ) {
        e.preventDefault()
      }
    },

    onSubmit() {
      if(this.$refs.bookingForm.validate()) {
        let params = {
          dateIn: this.dateIn,
          dateOut: this.dateOut,
          daysCnt: this.daysCnt,
          isPresent: this.isPresent,
          guestAdultCount: this.guestsLocal.find(i => i.alias === 'guestAdultCount').value,
          guestChildCount: this.guestsLocal.find(i => i.alias === 'guestChildCount').value,
          guestBabyCount: this.guestsLocal.find(i => i.alias === 'guestBabyCount').value,
        }
        this.fetchAvilableVariants(params)

        if(typeof ym !== 'undefined') {
          ym(process.env.VUE_APP_METRIKA_KEY,'reachGoal','podbor')
        }

        // формирование гет параметров и прокидывание в url,
        // что бы при возврате на 1 шаг происходил поиск по выбранным параметрам
        // бонус: такой ссылкой можно поделиться
        let baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname
        const paramStr = new URLSearchParams(params).toString()
        history.pushState(null, null, `${baseUrl}?${paramStr}`)
        this.updateGuests([...this.guestsLocal])
      }
    },

    onGuestsCntUpdate(obj) {
      const index = this.guestsLocal.findIndex(i => i.id === obj.id)
      this.guestsLocal[index].value = +obj.value
      // this.updateGuests([obj])
    }
  },

  beforeMount() {
    let params = getParams()
    let dateIn = null
    let dateOut = null
    let daysCnt = null
    let now = new Date()

    // инициализация стартовой даты
    if(params && params.dateIn) {
      dateIn = params.dateIn
    } else {
      dateIn = now.toISOString().substring(0, 10)
    }

    // инициализация минимального кол-ва дней
    if(params && params.daysCnt) {
      if(this.spaTour) {
        const daysThreshold = this.calculateSpaTourThreshold();
        if(new Date(dateIn) <= new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysThreshold)) {
          // если дата заезда не более двух недель от текущей
          switch(+params.daysCnt) {
            case 1:
              daysCnt = 2
              break
            case 4:
              daysCnt = 5
              break
            case 6:
              daysCnt = 7
              break
            default:
              daysCnt = +params.daysCnt
          }
        } else {
          // если дата заезда более двух недель от текущей
          daysCnt = (+params.daysCnt < this.minDays) ? this.minDays : +params.daysCnt
        }
      } else {
        daysCnt = (+params.daysCnt < this.minDays) ? this.minDays : +params.daysCnt
      }
    } else {
      daysCnt = this.defaultDaysCnt
    }

    // ининциализация конечной даты
    let dateInObj = new Date(Date.parse(dateIn))

    dateOut = new Date(
      dateInObj.getFullYear(),
      dateInObj.getMonth(),
      dateInObj.getDate() + (daysCnt > 1 ? daysCnt + 1 : daysCnt)
    )
      .toISOString()
      .substring(0, 10)

    this.dateIn = dateIn
    this.dateOut = dateOut
    this.daysCnt = daysCnt

    // массив дат для календаря
    this.dates = [dateIn, dateOut]

    // запись дат в store
    this.changeDateIn(dateIn)
    this.changeDateOut(dateOut)

    // инициализация кол-во гостей
    this.guestsLocal = this.guests.map(guest => {
      const tmp = { ...guest }
      if(params && params[tmp.alias]) tmp.value = +params[tmp.alias]
      return tmp
    })

    // Тип покупки (япокупаю/ядарю) из GET-параметров
    if(params && params.isPresent) {
      this.isPresent = params.isPresent.toLowerCase() === "true"
    }

    // если есть гет параметры, то выполняется поиск
    if(params) {
      this.searchOnMounted = true
    }
  },

  mounted() {
    if(this.searchOnMounted) {
      this.onSubmit()
    }
  }
}

function getParams() {
  let query = window.location.search
  return query ?
    query
    .replace('?','')
    .split('&')
    .reduce(
      function(p,e){
        var a = e.split('=');
        p[ decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
        return p;
      },
      {}
    )
    : null
}
</script>

<style lang="sass">
.booking-form
  width: 100%
  display: flex
  align-items: flex-end
  justify-content: center
  background-color: $prime-color
  color: #fff
  border-radius: px-em(15)
  padding: px-em(16) px-em(41)

.booking-form_fields
  min-width: 1px
  flex-grow: 1

.booking-form_fields-inner
  width: calc(100% + px-em(20))
  margin-left: px-em(-10)
  margin-right: px-em(-10)
  display: flex
  align-items: center

.booking-form_field
  padding: 0 px-em(10)

  &--dates,
  &--guests,
  &--days,
  &--buy-mode
    width: 25%

  &--buy-mode
    align-self: stretch
    display: flex
    flex-direction: column

.booking-form_field-label
  white-space: nowrap

.booking-form_actions
  flex-shrink: 0
  margin-left: px-em(38)

  .booking-form_action,
  .booking-form_action.ui-btn
    padding-left: px-em(26)
    padding-right: px-em(26)

.booking-form_field-input-wrapper
  --image-switch-height: 100%
  display: flex
  flex-direction: row
  align-items: center
  justify-content: center
  flex: 1
  width: 100%
  column-gap: 10px

.booking-form_field-switch-label
  text-wrap: nowrap
  cursor: pointer
  color: #fbeaea

  &--choose
    color: #fff
    font-weight: bold

@if $theme == yar
  .booking-form_actions
    margin-left: 1rem

  .booking-form_field
    &--guests,
    &--days
      width: 20%
    &--buy-mode
      width: 35%

@media screen and (max-width: $wide-screen-breakpoint)
  .booking-form_field-label
    font-size: 12px

  .booking-form_field-input-wrapper
    --image-switch-height: 80%

  .booking-form_field-switch-label
    font-size: 12px

  .booking-form_actions
    font-size: 12px
    flex: auto

  .booking-form_field
    overflow: hidden
    text-overflow: ellipsis

    &--guests,
    &--days
      width: 20%

    &--buy-mode
      width: 35%

  .booking-form_actions
    margin-left: .5rem

@media screen and (max-width: $mobile-breakpoint)
  .booking-form_field-label
    font-size: initial

  .booking-form
    flex-direction: column
    padding: px-em(12, 12) px-em(20, 12)

  .booking-form_fields
    width: 100%

  .booking-form_fields-inner
    width: 100%
    flex-direction: column
    margin-left: 0
    margin-right: 0

  .booking-form_field
    padding: 0

    &--dates,
    &--guests,
    &--days,
    &--buy-mode
      width: 100%

    + .booking-form_field
      margin-top: px-em(12, 12)

    &--buy-mode
      .booking-form_field-label
        display: none

  .booking-form_actions
    width: 100%
    margin-top: px-em(25, 12)
    font-size: initial
    flex: initial

  .booking-form_action,
  .booking-form_action.ui-btn
    width: 100%

  .booking-form_field-input-wrapper
    --image-switch-height: 3.6666666667em

  .booking-form_field-switch-label
    font-size: medium
</style>

